// @tenorlab/vue-dashboard-pro
// file: src/bundled-widgets/widget-accumulated-waterfall/meta.ts
import type { TWidgetMetaInfo } from '@tenorlab/vue-dashboard'
import { CircleQuestionMarkIcon as ComponentIcon } from 'lucide-vue-next'
import { markRaw } from 'vue'

// Define the metadata object for the plugin
export const WidgetAccumulatedWaterfallMeta: TWidgetMetaInfo = {
  name: 'Accumulated Waterfall Chart',
  categories: ['Chart'],
  icon: markRaw(ComponentIcon),
  noDuplicatedWidgets: true,
  description: 'A sample accumulated waterfall chart widget.',
  externalDependencies: [],
}
